import { Component, OnInit } from '@angular/core';
import { User } from '../../../models/user.model';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-departments-tabs-user',
  templateUrl: './departments-tabs-user.component.html',
  styleUrls: ['./departments-tabs-user.component.css']
})
export class DepartmentsTabsUserComponent implements OnInit {

  flag = true;
  user: User;
  isAdmin = false;
  isHead = false;
  isUser = false;

  constructor(public userService: UserService) { }

  ngOnInit() {
    this.checkRole();
  }

  change(data) {
    this.flag = data;
  }

  checkRole() {
    this.user = this.userService.getLocal();
    if (this.user.role === 'ROLE_ADMIN') {
      this.isAdmin = true;
    } else if (this.user.role === 'ROLE_HEAD') {
      this.isHead = true;
    } else if (this.user.role === 'ROLE_USER') {
      this.isUser = true;
    }
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/departments-tabs-user/departments-tabs-user.component.ts